import { createI18n } from 'vue-i18n';

import { CustomPlugin } from '@/types';
import { messages } from '@/locales';

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: 'ptBR',
  locale: 'ptBR',
  messages,
});

const plugin: CustomPlugin = {
  install: (app) => {
    app.use(i18n);
  },
};

export default plugin;
